<template>
  <q-card :style="$q.screen.lt.md?'':'width:700px;min-width:700px;'">
    <q-card-section class="no-padding">
      <q-banner class="bg-primary text-white">
        مرکز تماس
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-banner inline-actions
                :class="ahvazCallCenterIsLive? 'q-ma-xs bg-green-8 text-white rounded-borders':'q-ma-xs bg-red-8 text-white rounded-borders'">
        <template v-slot:avatar>
          <q-icon name="privacy_tip"/>
        </template>
        <p>
          {{
            ahvazCallCenterIsLive ? 'ارتباط با مرکز تماس برقرار اهواز می باشد' : 'ارتباط با مرکز تماس اهواز برقرار نمی باشد'
          }}
        </p>
      </q-banner>
      <q-banner inline-actions
                :class="tehranCallCenterIsLive? 'q-ma-xs bg-green-8 text-white rounded-borders':'q-ma-xs bg-red-8 text-white rounded-borders'">
        <template v-slot:avatar>
          <q-icon name="privacy_tip"/>
        </template>
        <p>
          {{
            tehranCallCenterIsLive ? 'ارتباط با مرکز تماس برقرار تهران می باشد' : 'ارتباط با مرکز تماس اهواز تهران نمی باشد'
          }}
        </p>
      </q-banner>

      <q-banner inline-actions class="q-ma-xs bg-red-8 text-white rounded-borders">
        <template v-slot:avatar>
          <q-icon name="privacy_tip"/>
        </template>
        <p>
          توجه داشته باشید که کلیه تماس های برقراری شما از طریق مرکز تماس نوران ذخیره و آرشیو می شوند
        </p>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-expansion-item
          class="shadow-1 overflow-hidden"
          style="border-radius: 10px"
          icon="phone"
          label="برقراری تماس آزاد"
          v-if="$store.state.roles.some(v=>['admin','free_call'].includes(v))"
          header-class="bg-indigo-10 text-white"
          expand-icon-class="text-white">
        <CallPanel :custom-call="true" :show-header="false"/>
      </q-expansion-item>
    </q-card-section>
    <q-card-section>
      <q-expansion-item
          class="shadow-1 overflow-hidden q-ma-xs"
          style="border-radius: 10px"
          v-if="$store.state.roles.some(v=>['admin','can_internal_call'].includes(v))"
          icon="phone"
          label="برقراری تماس داخلی"
          header-class="bg-indigo-10 text-white"
          expand-icon-class="text-white">
        <InternalCall :is-dialog="false" />
      </q-expansion-item>
    </q-card-section>
    <q-card-section>
      <q-expansion-item
          class="shadow-1 overflow-hidden q-ma-xs"
          style="border-radius: 10px"
          icon="phone"
          label="ارسال پیامک"
          header-class="bg-indigo-10 text-white"
          expand-icon-class="text-white"
          v-if="$store.state.roles.some(v=>['admin','can_send_sms'].includes(v))">
        <SMSPanel :standalone="true" :multiple="false" />
      </q-expansion-item>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import CallPanel from "@/components/callCenter/CallPanel";
import InternalCall from "@/components/callCenter/InternalCall";
import SMSPanel from "@/components/callCenter/SMSPanel.vue";

export default {
  name: "CallCenter",
  components: {SMSPanel, InternalCall, CallPanel},
  data() {
    return {
      customerPhone: '',
      customerLocalPhone: '',
      startDate: '',
      endDate: '',
      calls: [],
      onlyCustomer: false,
      au: undefined,
      filter: '',
      ahvazCallCenterIsLive: false,
      tehranCallCenterIsLive: false,
      smsMessage: '',
    }
  },
  methods: {
    ...mapActions({
      sendMessage: 'sendMessage',
      isCallCenterLive: 'isCallCenterLive',
      GetVoiceLogs: 'Requests/getVoiceLogs',
      GetCustomerPlayVoice: 'Customers/get_customer_phone_voice',
      sendSMS: 'send_sms_by_user',
      getMissCalled: 'Dashboard/getMissCalled'
    }),
    onSubmit() {
      this.$q.dialog({
        title: ' انتخاب محل پیش شماره',
        message: 'لطفا محل پیش شماره خود را انتخاب نمایید:',
        options: {
          type: 'radio',
          model: 'opt1',
          // inline: true,
          items: [
            {label: 'نوران - تهران', value: 'opt1', color: 'indigo'},
            {label: 'نوران - اهواز', value: 'opt2', color: 'indigo'},
            {label: 'نوران - صاف', value: 'opt3', color: 'indigo'},
            {label: 'تماس مستقیم', value: 'opt4', color: 'indigo'}
          ]
        },
        cancel: true,
        persistent: true
      }).onOk(data => {
        if (data === 'opt1') {
          if (this.$store.state.postfixPhone2 === null) {
            this.$q.notify({
              type: 'negative',
              position: 'top',
              color: 'negative',
              message: 'پیش شماره شما برای این مرکز تعریف نشده است'
            });
            return
          }
          this.sendMessageForConference(this.$store.state.postfixPhone2)
        }
        if (data === 'opt2') {
          if (this.$store.state.postfixPhone1 === null) {
            this.$q.notify({
              type: 'negative',
              position: 'top',
              color: 'negative',
              message: 'پیش شماره شما برای این مرکز تعریف نشده است'
            });
            return
          }
          this.sendMessageForConference(this.$store.state.postfixPhone1)
        }
        if (data === 'opt3') {
          if (this.$store.state.postfixPhone3 === null) {
            this.$q.notify({
              type: 'negative',
              position: 'top',
              color: 'negative',
              message: 'پیش شماره شما برای این مرکز تعریف نشده است'
            });
            return
          }
          this.sendMessageForConference(this.$store.state.postfixPhone3)
        }
        if (data === 'opt4') {
          if (this.$store.state.avayaExt === null || this.$store.state.avayaExt === '') {
            this.$q.notify({
              type: 'negative',
              position: 'top',
              color: 'negative',
              message: 'برای شما شماره داخلی تعریف نشده است'
            });
            return
          }
          this.sendMessageForDirectCall()
        }

      }).onCancel(() => {
        // console.log('>>>> Cancel')
      }).onDismiss(() => {
        // console.log('I am triggered on both OK and Cancel')
      })
    },
    onReset() {
      this.customerPhone = ''
      this.selectedPotfixPhone = ''
    },
    onLocalSubmit() {
      this.sendMessage(`${this.$store.state.internalUserMobile}&${this.$store.state.userMobile}&${this.customerLocalPhone}`).then((res) => {
        if (res.msg === 'success') {
          this.$q.notify({
            type: 'positive',
            position: 'top',
            color: 'positive',
            message: 'تا لحظاتی دیگر تماس شما از طریق مرکز تماس نوران برقرار خواهد شد، لطفا اندکی تامل فرمایید'
          });
        } else {
          this.$q.notify({
            type: 'negative',
            position: 'top',
            color: 'negative',
            message: 'ارتباط با مرکر تماس قطع است'
          });
          this.onReset();
        }
      }).catch(() => {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          color: 'negative',
          message: 'ارتباط با مرکر تماس قطع است'
        });
        this.onReset()
      });
    },
    onLocalReset() {
      this.customerLocalPhone = '';
    },
    loadVoiceData() {
      if (this.startDate !== '' && this.endDate !== '') {
        this.GetVoiceLogs({
          startDate: this.ToGregorianDateTime(this.startDate),
          endDate: this.ToGregorianDateTime(this.endDate)
        }).then((res) => {
          this.calls = this.lodash.orderBy(res, ['Starttime'], ['desc'])
        })
      }
    },
    onSMSSubmit() {
      this.sendSMS({
        phoneNo: this.customerPhone,
        Message: this.smsMessage
      }).then(() => {
        this.$q.notify({
          type: 'positive',
          position: 'top',
          color: 'positive',
          message: 'پیامک شما ارسال گردید'
        });
        this.onSMSReset()
      })
    },
    onSMSReset() {
      this.customerPhone = ''
      this.smsMessage = ''
    },
    sendMessageForConference(postfix) {
      this.sendMessage(`${this.$store.state.internalUserMobile}&${postfix}${this.$store.state.userMobile}&${postfix}${this.customerPhone}`).then((res) => {
        if (res.msg === 'success') {
          this.$q.notify({
            type: 'positive',
            position: 'top',
            color: 'positive',
            message: 'تا لحظاتی دیگر تماس شما از طریق مرکز تماس نوران برقرار خواهد شد، لطفا اندکی تامل فرمایید'
          });
        } else {
          this.$q.notify({
            type: 'negative',
            position: 'top',
            color: 'negative',
            message: 'ارتباط با مرکر تماس قطع است'
          });
          this.onReset();
        }
      }).catch(() => {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          color: 'negative',
          message: 'ارتباط با مرکر تماس قطع است'
        });
        this.onReset()
      });
    },
    sendMessageForDirectCall() {
      this.sendMessage(`${this.$store.state.avayaExt}&${this.customerPhone}`).then((res) => {
        if (res.msg === 'success') {
          this.$q.notify({
            type: 'positive',
            position: 'top',
            color: 'positive',
            message: 'تا لحظاتی دیگر تماس شما برقرار خواهد شد، لطفا اندکی تامل فرمایید'
          });
        } else {
          this.$q.notify({
            type: 'negative',
            position: 'top',
            color: 'negative',
            message: 'ارتباط با مرکر تماس قطع است'
          });
          this.onReset();
        }
      }).catch(() => {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          color: 'negative',
          message: 'ارتباط با مرکر تماس قطع است'
        });
        this.onReset()
      });
    }

  },
  created() {
    this.isCallCenterLive("1").then(() => {
      this.ahvazCallCenterIsLive = true
    }).catch(() => {
      this.ahvazCallCenterIsLive = false
    });

    this.isCallCenterLive("892").then(() => {
      this.tehranCallCenterIsLive = true
    }).catch(() => {
      this.tehranCallCenterIsLive = false
    });

  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
  border: none;
}
</style>
